import React from "react";

import TableContainer from "../../../components/LightPurpleContainer";
import { makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(5, 0),
    backgroundColor: "#fff",
  },
  mobile: {
    [theme.breakpoints.only("xs")]: {
      padding: theme.spacing(0, 2),
    },
  },
}));

export default function NoRequests() {
  const classes = useStyles();
  return (
    <TableContainer>
      <div className={classes.container}>
        <Typography variant="h5" color="secondary" className={classes.mobile}>
          Trenutno nema zahtjeva na čekanju.
        </Typography>
      </div>
    </TableContainer>
  );
}
